import React from "react";
import BannerSection from "../Component/BannerSection";
import Layout from "../Component/Layout/Layout";

const ProductAndService = () => {
  return (
    <Layout>
      <BannerSection
        title="Home"
        image="/images/product&service_banner.jpeg"
        description="Product And Service Disclaimer"
        heading="Product And Service Disclaimer"
      />
      <div className="container my-5">

        <h2 className="mt-4 mb-3 fw-bold">1. Food Allergens</h2>
        <p>
          While we take precautions to accommodate dietary restrictions, Afrikan
          BBQ LLC cannot guarantee the absence of allergens in our products.
          Please inform us of any food allergies or sensitivities before placing
          your order.
        </p>

        <h2 className="mt-4 mb-3 fw-bold">2. Product Availability</h2>
        <p>
          All products are subject to availability. Prices and offerings may
          change without notice.
        </p>

        <h2 className="mt-4 mb-3 fw-bold">3. Health and Safety</h2>
        <p>
          Afrikan BBQ LLC complies with all local health and safety regulations.
          However, by consuming our products, customers assume all risks
          associated with food preparation and consumption.
        </p>

        <div className="mt-5 text-center">
          <p className="fw-bold">Thank you for choosing Afrikan BBQ LLC.</p>
          <p className="text-muted">We look forward to serving you!</p>
        </div>
      </div>
    </Layout>
  );
};

export default ProductAndService;
